import { PhotonClient } from "../PhotonClient";

import {
    DefaultGetTime,
    fixedDelay,
    GetTimeCallback,
    millisecondsPerStep,
    StepPayload,
    StepPayloadType,
} from "./common";

const latencyThreshold = 600;

export class RemoteTime {
    private startTime = 0;

    private startStep = 0;

    private adjustedDelay: number;

    constructor(
        private photonClient: PhotonClient,
        private getTimeCallback: GetTimeCallback = DefaultGetTime,
    ) {
        this.handleEvent = this.handleEvent.bind(this);
        this.adjustedDelay = fixedDelay;
    }

    public start() {
        this.photonClient.events.on(StepPayloadType, this.handleEvent);
    }

    public stop() {
        this.photonClient.events.off(StepPayloadType, this.handleEvent);
    }

    private handleEvent(event: StepPayload) {
        const currentTime = this.getTimeCallback();
        this.startTime = event.time;
        this.startStep = event.step;

        const latency = currentTime - event.time;
        // console.log("latency", latency);
        if (latency > latencyThreshold && this.adjustedDelay < latency) {
            console.warn(`Detected high latency: ${latency}`);
            // adjust fixedDelay
            if (this.adjustedDelay < latency + 100) {
                this.adjustedDelay = latency > 2000 ? 2000 : latency;
                console.log("new adjusted delay fixed to", this.adjustedDelay);
            }
        }
    }

    public currentStep(): number {
        const currentTime = this.getTimeCallback();
        const stepDelta = Math.ceil(
            (currentTime - this.startTime - this.adjustedDelay) /
                millisecondsPerStep,
        );
        // console.log("start step", this.startStep, "stepDelta", stepDelta);
        // console.log(
        //     "before floor",
        //     (currentTime - this.startTime - fixedDelay) / millisecondsPerStep,
        // );
        return this.startTime === 0 ? 0 : this.startStep + stepDelta;
    }
}
